module.exports = __webpack_public_path__ + "img/p_tgd.cdb7b6ba.png";